/**
 * High5 günlük hedef / gerçekleşen — /high5/mtd-hedef ve /high5/haftalik-mail
 * (yazının hedef bölümü) AYNI diziyi okur.
 *
 * 🔴 STATİK: rakamlar müşterinin günlük hedef Excel'inden elle yapıştırıldı
 * (Efe, 28 Eyl 2026; Eyl sonu + Ekim 1–4 eklendi 5 Eki; 5–11 Eki eklendi 12 Eki; 12–18 Eki eklendi 19 Eki; 19–25 Eki eklendi 26 Eki; 26–31 Eki eklendi 2 Kas, cost'u DB'den Google+Meta+Criteo toplamı — ciro/TRX müşteri Excel KDV dahil, cost müşterinin günlük hedef tablosu, Google+Meta+Criteo). Canlı kaynağa bağlı DEĞİL — yeni gün eklemek için
 * aşağıdaki DATA dizisine satır ekle. Fatura sütunları bilerek alınmadı.
 *
 * Satır: [gün, hedef ciro, gerçekleşen ciro, hedef TRX, gerçekleşen TRX, hedef cost, gerçekleşen cost]
 * Gerçekleşen null = gün henüz kapanmadı.
 */
export const DATA = {
  '2026-07': [
    [1, 292600, 258020, 25, 28, 34424, 27567], [2, 336600, 237163, 29, 24, 39600, 31362],
    [3, 292600, 210654, 25, 24, 34424, 34253], [4, 292600, 269305, 25, 23, 34424, 42210],
    [5, 366300, 318932, 32, 28, 43094, 42541], [6, 248600, 271822, 22, 24, 29247, 39658],
    [7, 292600, 282382, 25, 34, 34424, 42913], [8, 292600, 371124, 25, 29, 34424, 40485],
    [9, 336600, 376291, 29, 34, 39600, 39017], [10, 292600, 216934, 25, 23, 34424, 37979],
    [11, 292600, 225240, 25, 19, 34424, 37135], [12, 366300, 198414, 32, 19, 43094, 42025],
    [13, 248600, 230363, 22, 21, 29247, 33989], [14, 292600, 265245, 25, 23, 34424, 38028],
    [15, 292600, 317417, 25, 24, 34424, 41414], [16, 336600, 300422, 29, 25, 39600, 40328],
    [17, 292600, 327236, 25, 30, 34424, 46958], [18, 292600, 394193, 25, 32, 34424, 45124],
    [19, 366300, 300673, 32, 27, 43094, 45370], [20, 248600, 427989, 22, 38, 29247, 43587],
    [21, 292600, 385109, 25, 40, 34424, 46181], [22, 292600, 304107, 25, 31, 34424, 46390],
    [23, 336600, 281959, 29, 25, 39600, 44492], [24, 292600, 421840, 25, 40, 34424, 44285],
    [25, 292600, 273650, 25, 26, 34424, 40536], [26, 366300, 228974, 32, 25, 43094, 43593],
    [27, 248600, 262457, 22, 29, 29247, 36904], [28, 292600, 229330, 25, 24, 34424, 36684],
    [29, 292600, 284566, 25, 27, 34424, 27964], [30, 336600, 241392, 29, 27, 39600, 29166],
    [31, 292600, 420013, 25, 34, 34424, 29400],
  ],
  '2026-08': [
    [1, 374000, 276773, 35, 24, 41940, 28585], [2, 396000, 216224, 37, 20, 41940, 33004],
    [3, 407000, 265099, 38, 27, 41940, 29362], [4, 363000, 430172, 34, 43, 41935, 44156],
    [5, 363000, 541745, 34, 34, 41935, 44194], [6, 385000, 429282, 36, 37, 41935, 48871],
    [7, 352000, 245697, 33, 26, 41935, 45801], [8, 374000, 457276, 35, 46, 41935, 59399],
    [9, 396000, 281665, 37, 33, 41935, 55091], [10, 407000, 575245, 38, 46, 41935, 51804],
    [11, 363000, 389888, 34, 45, 41935, 50674], [12, 363000, 422878, 34, 44, 41935, 43039],
    [13, 385000, 300666, 36, 30, 41935, 39715], [14, 352000, 259977, 33, 26, 41935, 35713],
    [15, 374000, 304158, 35, 26, 41935, 34889], [16, 396000, 313590, 37, 29, 41935, 39822],
    [17, 407000, 364095, 38, 31, 41935, 38990], [18, 363000, 317602, 34, 30, 41935, 47770],
    [19, 363000, 424646, 34, 37, 41935, 43390], [20, 385000, 406009, 36, 38, 41935, 46737],
    [21, 363000, 309607, 34, 29, 41935, 39721], [22, 374000, 191401, 35, 22, 41935, 45321],
    [23, 396000, 240993, 37, 25, 41935, 56224], [24, 407000, 251577, 38, 27, 41935, 45401],
    [25, 363000, 334213, 34, 30, 41935, 47721], [26, 363000, 410351, 34, 35, 41935, 49182],
    [27, 385000, 462425, 36, 39, 41935, 52092], [28, 352000, 376202, 33, 34, 41935, 52384],
    [29, 374000, 285000, 35, 25, 41935, 51770], [30, 396000, 503536, 37, 44, 41935, 53657],
    [31, 418000, 364313, 39, 33, 41935, 54016],
  ],
  '2026-09': [
    [1, 418000, 282070, 35, 30, 53333, 55889], [2, 462000, 442566, 38, 43, 53333, 52794],
    [3, 506000, 329266, 42, 28, 53333, 54695], [4, 440000, 274572, 36, 27, 53333, 56687],
    [5, 418000, 328498, 35, 28, 53333, 54211], [6, 550000, 467183, 45, 50, 53333, 58793],
    [7, 495000, 512984, 41, 44, 53333, 54407], [8, 418000, 382097, 35, 37, 53333, 59690],
    [9, 462000, 477962, 38, 44, 53333, 60206], [10, 506000, 425730, 42, 40, 53333, 52943],
    [11, 440000, 396625, 36, 27, 53333, 55720], [12, 418000, 438001, 35, 34, 53333, 63008],
    [13, 550000, 544180, 45, 31, 53333, 72704], [14, 495000, 294734, 41, 31, 53333, 57365],
    [15, 418000, 527589, 35, 38, 53333, 61693], [16, 462000, 294785, 38, 23, 53333, 60282],
    [17, 506000, 384233, 42, 34, 53333, 61003], [18, 440000, 209356, 36, 25, 53333, 60155],
    [19, 418000, 226925, 35, 27, 53333, 61905], [20, 550000, 352666, 45, 32, 53333, 63397],
    [21, 495000, 398580, 41, 34, 53333, 61347], [22, 418000, 527661, 35, 36, 53333, 64607],
    [23, 462000, 309472, 38, 27, 53333, 58893], [24, 506000, 377727, 42, 34, 53333, 59309],
    [25, 440000, 228645, 36, 18, 53333, 52619], [26, 418000, 312467, 35, 26, 53333, 57698],
    [27, 550000, 475062, 45, 37, 53333, 66140], [28, 495000, 446691, 41, 33, 53333, 54860],
    [29, 418000, 533923, 35, 39, 53333, 59273], [30, 462000, 447720, 38, 37, 53333, 56574],
  ],
  '2026-10': [
    [1, 490938, 353735, 42, 29, 60074, 61255], [2, 346915, 322979, 29, 27, 58994, 59351],
    [3, 412956, 355387, 35, 32, 56512, 57787], [4, 526223, 448415, 45, 31, 62733, 62154],
    [5, 499512, 372319, 42, 30, 58941, 61783], [6, 504311, 488377, 43, 34, 60120, 60617],
    [7, 487153, 412754, 41, 32, 61231, 63038], [8, 490938, 485144, 42, 36, 60074, 58584],
    [9, 346915, 429007, 29, 31, 58994, 55360], [10, 412956, 199167, 35, 19, 56512, 61993],
    [11, 526223, 330024, 45, 28, 62733, 60830], [12, 499512, 557086, 42, 44, 58941, 62588],
    [13, 504311, 461811, 43, 39, 60120, 57715], [14, 487153, 483521, 41, 32, 61231, 57491],
    [15, 490938, 490259, 42, 41, 60074, 59443], [16, 346915, 615806, 29, 51, 58994, 56168],
    [17, 412956, 512243, 35, 47, 56512, 69628], [18, 526223, 649116, 45, 58, 62733, 65546],
    [19, 499512, 729017, 42, 65, 58941, 65883], [20, 504311, 511150, 43, 40, 60120, 62914],
    [21, 487153, 517891, 41, 41, 61231, 63440], [22, 490938, 432357, 42, 37, 60074, 61905],
    [23, 346915, 540842, 29, 37, 58994, 61870], [24, 412956, 569910, 35, 39, 56512, 61457],
    [25, 526223, 476995, 45, 43, 62733, 70311], [26, 499512, 337592, 42, 34, 58941, 53413],
    [27, 504311, 524639, 43, 42, 60120, 52295], [28, 487153, 531611, 41, 53, 61231, 55485],
    [29, 490938, 573221, 42, 39, 60074, 62609], [30, 346915, 351955, 29, 29, 58994, 50317],
    [31, 412956, 406911, 35, 32, 56512, 52245],
  ],
};
